import { AuthResponse, AuthTokenResponse, PostgrestSingleResponse, UserResponse } from "@supabase/supabase-js";

export default function withErrorCheck<T>(
  response: PostgrestSingleResponse<T> | AuthTokenResponse | AuthResponse | UserResponse
): T {
  if (response.error) {
    throw response.error;
  }
  return response.data as T;
}
